import path from "node:path";
import { AssetManager } from "@skaile/workspaces/asset-manager";
import { Command } from "commander";
import { logInfo } from "../helpers.ts";

/**
 * Creates the `skaile diff` command.
 *
 * Shows the unified diff between the deployed version of an asset and its
 * current source file in the repository clone.
 *
 * @returns Configured {@link Command} ready for `program.addCommand()`.
 * @docLink cli/commands/diff#make-diff-command
 */
export function makeDiffCommand(): Command {
  return new Command("diff")
    .description("Show changes between deployed and source versions")
    .argument("<ref>", "Asset reference (kind:name)")
    .option("--project-dir <path>", "Project directory", process.cwd())
    .action((ref: string, opts) => {
      const am = new AssetManager({ projectDir: path.resolve(opts.projectDir) });
      const result = am.diff(ref);
      if (result === null) {
        logInfo("No differences (or asset not found).");
        return;
      }
      console.log(result);
    });
}
